var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.34,
    cy: 17.34,
    r: 10.34,
    fill: "#00984A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7989 13.3078C26.6331 10.8005 25.39 8.45916 23.4214 6.90511C21.4531 5.35091 18.8836 4.70861 16.3971 5.12299C11.9629 5.88976 8.70972 9.99234 9.02053 14.5094C9.16565 16.6852 10.0772 18.695 11.6106 20.2284C11.2169 20.8085 10.8647 21.1816 9.93228 21.9275C9.74582 22.0726 9.66286 22.3004 9.72501 22.5283C9.76649 22.7563 9.93228 22.9427 10.1394 23.0049C10.4501 23.1085 10.906 23.15 11.424 23.15C12.5222 23.15 13.9105 22.9014 14.988 22.3419C16.4177 22.8392 17.951 22.9636 19.4636 22.6941C23.8979 21.9067 27.1097 17.7835 26.7989 13.3078ZM13.7656 15.5248C12.9575 15.5248 12.3152 14.8825 12.3152 14.0744C12.3152 13.2663 12.9575 12.624 13.7656 12.624C14.5737 12.624 15.216 13.2663 15.216 14.0744C15.216 14.8825 14.5737 15.5248 13.7656 15.5248ZM17.9097 15.5248C17.1016 15.5248 16.4593 14.8825 16.4593 14.0744C16.4593 13.2663 17.1016 12.624 17.9097 12.624C18.7178 12.624 19.3601 13.2663 19.3601 14.0744C19.3601 14.8825 18.7178 15.5248 17.9097 15.5248ZM22.0539 15.5248C21.2458 15.5248 20.6035 14.8825 20.6035 14.0744C20.6035 13.2663 21.2458 12.624 22.0539 12.624C22.862 12.624 23.5043 13.2663 23.5043 14.0744C23.5043 14.8825 22.862 15.5248 22.0539 15.5248Z",
    fill: "#00984A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon3);
export default __webpack_public_path__ + "static/media/left-icon3.b07ae4ef78ee63336973414f659057cd.svg";
export { ForwardRef as ReactComponent };